import { useTranslation } from "react-i18next";
import TabsNavigationBar from "../../components/bar/TabsNavigationBar/TabsNavigationBar";

function ClauseNavigationBar(props) {
    const { t } = useTranslation();
    return (
        <TabsNavigationBar
            multipleLocationKey={props.multipleLocationKey}
            pages={[
                {
                    label: t("headers.clauses_list"),
                    link: "/clauses-admin/",
                },
                {
                    label: t("headers.clauses_history"),
                    link: "/clauses-history/",
                },
            ]}
        />
    );
}

export default ClauseNavigationBar;
